import { createContext, useContext } from 'react';

export interface NavbarSlots {
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
}

export interface NavbarContextValue {
  leftSlot: React.ReactNode;
  rightSlot: React.ReactNode;
  setSlots: (slots: NavbarSlots) => void;
  clearSlots: () => void;
}

export const NavbarContext = createContext<NavbarContextValue>({
  leftSlot: null,
  rightSlot: null,
  setSlots: () => {},
  clearSlots: () => {},
});

export const useNavbarSlotContext = () => useContext(NavbarContext);
